import { useEffect, useState } from "react";
import { ProCard } from "@ant-design/pro-components";
import { Button, Table, Space, Breadcrumb, notification, DatePicker, Modal, Form, Input, Spin, Typography, Tooltip, Select } from "antd";
import { useResourceNavigate } from "@/hooks/useResourceNavigate";
import { addTokens, getTokens, listUsersInTenant, revokeTokens, udpateTokens } from "@/apis";
import { CiCircleFilled, CodepenOutlined, EditOutlined, LoadingOutlined, MinusOutlined, PlusOutlined } from "@ant-design/icons"; 
import dayjs from 'dayjs';
import { TopBreadcrumb } from "@/layouts/TopBreadcrumb";
import { useResourceContext } from "@/layouts/ResourceContext";

export const ManageToken = ({ id, goto }) => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useResourceNavigate();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalOkDisabled, setIsModalOkDisabled] = useState(true);
  const [modalForm] = Form.useForm();
  const [tokens, setTokens] = useState([]);
  const [editingIndex, setEditingIndex] = useState(null);
  const [editingValue, setEditingValue] = useState('');
  const { Text } = Typography;
  const { tenantName } = useResourceContext();
  const [tenantUsers, setTenantUsers] = useState([]);
  useEffect(() => {
    const fetchTokens = async () => {
      try {
        setIsLoading(true);
        const tokens = await getTokens(id);
        setIsLoading(false);
        if (tokens != null && tokens.length > 0) {
          setTokens(tokens);
        } else {
          setTokens([]);
        }
      } catch (error) {
        console.error("get built-in users failed:", error);
      }
    };

    fetchTokens();
  }, [id]);

  useEffect(() => {
    const fetchTenantUsers = async () => {
      try {
        setIsLoading(true);
        const response = await listUsersInTenant(tenantName);
        setIsLoading(false);
        let tenantUsers = response.value || [];
        let i = 1;
        setTenantUsers(tenantUsers);      
      } catch (error) {
        console.error("get users failed:", error);
      }
    };
  
    fetchTenantUsers();
  }, [tenantName]);

  const handleAdd = () => {
    setIsModalVisible(true);
  };

  const handleModalOk = () => {
    modalForm.validateFields().then(values => {
      const expiredTime = values.expiredTime? dayjs(values.expiredTime).toISOString(true).replace(/\.\d{3}Z$/, 'Z') : ""
      const newData = {
        user: values.user,
        label: values.label,
        expiredTime: expiredTime,
      };
      addTokens(id, newData).then(({ status, value }) => {
        if (status === 'OK') {
          newData["token"] = value;
          setTokens([...tokens, newData]);
        } else {
          notification.error({
            description: 'Add token failed!'
          });
        }
      }).catch((error) => {

      }).finally(() => {
        setIsModalVisible(false);    
        modalForm.resetFields();
        setIsModalOkDisabled(true);
      });      
    }).catch(info => {
      console.log('Validate Failed:', info);
    });
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
    modalForm.resetFields();
    setIsModalOkDisabled(true);
  };
  const handleModalValuesChange = () => {
    modalForm.validateFields().then(() => {
      setIsModalOkDisabled(false);
    }).catch(() => {
      //setIsModalOkDisabled(true);
      setIsModalOkDisabled(false);
    });
  };

  const handleDelete = (token) => {
    const revokeItem = tokens.find(item => item.token == token);
    Modal.confirm({
      title: 'Delete Token',
      content: 'Are you sure to delete ' + revokeItem.user + '\'s token \:\'' + token + '\'?' ,
      centered: true,
      onOk: () => {
        if(revokeItem) {
          const revokeObj = {
            user : revokeItem.user,
            tokens: token
          }
          revokeTokens(id, revokeObj).then(({ status, value }) => {
            if (status === 'OK') {
              const newData = tokens.filter((item) => item.token !== token);
              setTokens(newData);
              notification.success({
                description: 'Revoke token success!'
              });
            } else {
              notification.error({
                description: 'Delete token failed!'
              });
            }
          })
        }
      },
      onCancel: () => {
        console.log("Cancel delete");
      },
    });
    
  };

  // const edit = (key) => {

  // };

  const handleEdit = (key, index, text) => {
    if(!editingIndex || editingIndex !== key + "_" + index) {
      setEditingIndex(key + "_" + index);
      setEditingValue(text);
    }
  };

  const doSave = (key, value, token) => {
    let updateObj;
    const newData = tokens.map(item => {  
      if (item.token === token) {  
        const updateItem = { ...item, [key]: value }; // 返回一个新对象，其中 field 字段被修改
        const { user, label, expiredTime, token} = updateItem;
        updateObj = {user, label, "expiredTime": expiredTime ? dayjs(expiredTime).toISOString(true).replace(/\.\d{3}Z$/, 'Z') : "", "tokens": token};
        return updateItem;
      }  
      return item; // 返回原对象  
    });  
    setIsLoading(true);
    udpateTokens(id, updateObj).then(({ status, value }) => {
      setIsLoading(false);
      if (status === 'OK') {
        setTokens(newData);
      } else {
        notification.error({
          description: 'Update token failed!'
        });
      }
    }).catch((error) => {
      
    }).finally(() => {
      setEditingIndex("");
    })    
  };

  const columns = [
    {
      title: "User",
      dataIndex: "user",
      width: '10%'
    },
    {
      title: "Label",
      dataIndex: "label",
      render: (text, record, index) => (
        editingIndex === "label_" + index ? (
          <Input
            autoFocus='true'
            value={editingValue}
            onChange={(e) => setEditingValue(e.target.value)}
            onPressEnter={(e) => {
              editingValue != record.label && doSave("label", e.target.value, record.token);
              setEditingIndex("");
            }} 
            onBlur={(e) => {
              editingValue != record.label && doSave("label", e.target.value, record.token);
              setEditingIndex("");
            }}
          />
        ) : (
          <div>{text}</div>
        )
      ),
      width: '10%',
      onCell: (record, index) => ({
        onClick: ()=> handleEdit('label', index, record.label),
        style: { cursor: 'pointer' }, // 设置光标为手形
      }),
    },
    {
      title: "ExpiredTime",
      dataIndex: "expiredTime",
      render: (text, record, index) => (
        editingIndex === "expiredTime_" + index ? (
          <DatePicker 
            autoFocus='true'
            showTime='true'
            value={editingValue ? dayjs(editingValue) : ''}
            format="YYYY-MM-DD HH:mm:ss"
            onOpenChange={()=>{
              console.log("open");
            }}
            onPanelChange={()=>{
              console.log("panel change");
            }}
            onChange={(date, dateString) => {
              console.log("change");
              setEditingValue(dateString);
              doSave("expiredTime", dateString, record.token);
            }}
            onBlur={(e)=>{
              console.log("blur");
              if(!e.nativeEvent.relatedTarget)
                setEditingIndex("");
            }}
          />
        ) : (
          <div>{text}</div>
        )
      ),
      width: '15%',
      onCell: (record, index) => ({
        onClick: ()=> handleEdit('expiredTime', index, record.expiredTime),
        style: { cursor: 'pointer' }
      }),
    },
    {
      title: "Token",
      dataIndex: "token",
      render: (text) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Text copyable ellipsis style={{ maxWidth: 380 }}>
            {text}
          </Text>
        </div>
      ),  
      width: 400
    },
    {
      title: "Created",
      dataIndex: "created"
    },
    {
      title: "Last Used",
      dataIndex: "lastUsed"
    },
    {
      title: '',
      width: 30,
      render: (_, record) => <Button size="small" shape="circle" icon={<MinusOutlined />} onClick={() => handleDelete(record.token)} />,
    },
  ];
  return (
    <div>
      <TopBreadcrumb />
      <ProCard split="vertical" style={{ marginTop: 20 }}>
        <ProCard title={
          <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ display: 'flex', width: '100%', fontSize: 18, fontWeight: 500 }}>Manage Token of AIOps instance</div>
          </div>
        } extra={
          <Button size="small" shape="circle" icon={<PlusOutlined />} onClick={handleAdd} />
        } headerBordered colSpan="100%" headStyle={{ width: '100%' }}>
          <Spin tip="Loading" size="large" spinning={isLoading} indicator={<LoadingOutlined spin />}> 
          <Table columns={columns} dataSource={tokens}>

          </Table>
          </Spin>
          <Space>
            <Button onClick={() => {
              navigate({ resource: goto, action: "list" });
            }}>Close</Button>
          </Space>
        </ProCard>
      </ProCard>
      <Modal
        title="Add Token"
        open={isModalVisible}
        onOk={handleModalOk}
        onCancel={handleModalCancel}
        okButtonProps={{ disabled: isModalOkDisabled }}
      >
        <Form form={modalForm} layout="vertical" onValuesChange={handleModalValuesChange}>
        <Form.Item
            name="user"
            label="User Name"
            rules={[
              {
                required: true,
              }
            ]}
          >
            <Select showSearch options={tenantUsers.filter(tenantUser => { return !tokens.some(token => tenantUser.name === token.user);}).map((user) => {return {value: user.name, label: user.name}})}/>
          </Form.Item>
          <Form.Item
            name="label"
            label="Label"
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="expiredTime"
            label="Expired Time"
          >
            <DatePicker showTime='true' />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};